import React, { useState, useEffect } from "react";
import axiosInstance from "../../services/auth";
import ReactPaginate from "react-paginate";
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";
import VesselForm from "./VesselForm";
import VesselView from "./VesselView";
import { useCombinedContext } from "../../context/CombinedContext";
import exportToExcel from "../Excel/ExportToExcel";
import * as XLSX from "xlsx";
import Budget from "./Budget";
import Hours from "./Hours";

const VesselList = () => {
  const [vessel, setVessel] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [selectedData, setSelectedData] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [isViewMode, setIsViewMode] = useState(false);
  const [fromDate, setFromDate] = useState(""); // Start date for filtering
  const [toDate, setToDate] = useState(""); // End date for filtering
  const [loading, setLoading] = useState(false);
  const [viewBudget, setViewBudget] = useState(false);
  const [viewHours, setViewHours] = useState(false);
  const [itemsPerPage, setItemsPerPage] = useState(5);

  const { selectedCompany } = useCombinedContext();

  const companyId = selectedCompany?._id;
  // console.log("company in vessel:", selectedCompany);

  const authData =
    JSON.parse(localStorage.getItem("authData")) ||
    JSON.parse(sessionStorage.getItem("authData"));

  const userRole = authData.role;
  // console.log("vessel data", vessel);
  // console.log("This is Selected ", selectedData);
  useEffect(() => {
    if (companyId) {
      fetchVessel();
    }
  }, [companyId, fromDate, toDate]);

  const fetchVessel = async () => {
    try {
      setLoading(true);
      const params = {};
      if (fromDate) params.start_date = fromDate;
      if (toDate) params.end_date = toDate;
      const response = await axiosInstance.get(
        `/vessel/${companyId}/datewise`,
        {
          params,
        },
      );
      // console.log("vessel response", response);
      setVessel(response.data.data || []);
      setFilterData(response.data.data || []);
    } catch (error) {
      // console.error("Error fetching vessel:", error);
      toast.error("Error fetching vessel");
    } finally {
      setLoading(false);
    }
  };

  // Filter Job Location
  const handleSearchChange = (e) => {
    const searchText = e.target.value.toLowerCase();
    const filteredLocation = vessel.filter(
      (vessel) =>
        vessel.vessel_name.toString().toLowerCase().includes(searchText) ||
        vessel.vessel_code.toString().toLowerCase().includes(searchText) ||
        vessel.project_code.toString().toLowerCase().includes(searchText) ||
        vessel?.supplier?.code.toString().toLowerCase().includes(searchText),
    );
    setFilterData(filteredLocation);
  };

  const deleteCompany = async (_id) => {
    try {
      await axiosInstance.delete(`/vessel/${_id}`);
      fetchVessel();
    } catch (error) {
      // console.error("Error deleting company:", error);
      toast.error("Error deleting vessel");
    }
  };
  //Delete Data
  const handleDelete = (id) => {
    setDeleteTarget(id); // Set the target ID for deletion
    setIsDeleteModalOpen(true);
  };
  const confirmDelete = async () => {
    if (!deleteTarget) return; // Ensure a valid target is set
    try {
      await axiosInstance.delete(`/vessel/${deleteTarget}`);
      setVessel((prev) => prev.filter((loc) => loc._id !== deleteTarget));
      setFilterData((prev) => prev.filter((loc) => loc._id !== deleteTarget));
      setIsDeleteModalOpen(false); // Close the modal after successful deletion
      setDeleteTarget(null); // Clear the delete target
      toast.success("Location deleted successfully");
    } catch (error) {
      setIsDeleteModalOpen(false);
      // console.error("Error deleting Vessel:", error);
      toast.error(error.response?.data?.message || "Failed to delete vessel");
    }
  };

  //Handle Page Location
  const handlePageClick = (selectedPage) => {
    setCurrentPage(selectedPage.selected);
  };
  // const itemsPerPage = 5;
  const currentItems = [...filterData]
    .reverse()
    .slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage);
  const pageCount = Math.ceil(filterData.length / itemsPerPage);

  const handleExportexcel = () => {
    const isAdmin = userRole === "admin" || userRole === "superadmin";

    const headers = [
      "S.No.",
      "Vessel Name",
      "Vessel Code",
      "Company Name",
      "Company Code",
      "Project Code",
      "Job Start Date",
      "Job End Date",
      "Job Location",
      "Job Location (code)",
      "Month (Hours)",
      "Piping Trade",
      "Piping Manual Entry HRS",
      "Piping ISRP Main HRS",
      "Piping Total HRS (PF)",
      "Mechanical Trade",
      "Mechanical Manual Entry HRS",
      "Mechanical ISRP Main HRS",
      "Mechanical Total HRS (ME)",
      "Total HRS",
      "Total Vessel HRS",
      "Hour Remarks",
    ];

    if (isAdmin) {
      headers.push(
        "Month (Budget)",
        "Budget Amount",
        "Total Budget Amount",
        "Invoice Total Amount",
        "Total amount per hour from invoice",
        "Invoice - Budget",
      );
    }

    headers.push("Vessel Remarks");

    let tableData = [headers];
    let mergeInstructions = [];
    let currentRow = 1;
    let serialNo = 1;

    filterData.forEach((vessel) => {
      const maxRows = Math.max(
        vessel.hours?.length || 1,
        vessel.budget?.length || 1,
      );

      const totalBudgetAmount = (vessel.budget || []).reduce(
        (sum, b) => sum + (b.amount || 0),
        0,
      );

      const totalVesselHrs = (vessel.hours || []).reduce((sum, h) => {
        const pipingHrs = Number(h?.piping_dept?.total_hrs_pf || 0);
        const mechHrs = Number(h?.mechanical_dept?.total_hrs_me || 0);
        return sum + pipingHrs + mechHrs;
      }, 0);

      for (let i = 0; i < maxRows; i++) {
        const hour = vessel.hours?.[i];
        const budget = vessel.budget?.[i];

        const totalHrs = hour
          ? Number(hour?.piping_dept?.total_hrs_pf || 0) +
            Number(hour?.mechanical_dept?.total_hrs_me || 0)
          : 0;

        const differamount =
          vessel.total_amount_from_invoices - totalBudgetAmount;
        const perhour = vessel.total_amount_from_invoices / totalVesselHrs;

        const row = [
          serialNo,
          vessel.vessel_name || "N/A",
          vessel.vessel_code || "N/A",
          vessel.companyId?.company_name || "N/A",
          vessel.companyId?.company_code || "N/A",
          vessel.project_code || "N/A",
          vessel.job_start
            ? new Date(vessel.job_start).toLocaleDateString()
            : "N/A",
          vessel.job_end
            ? new Date(vessel.job_end).toLocaleDateString()
            : "N/A",
          vessel.supplier?.yard_name || "N/A",
          vessel.supplier?.code || "N/A",
          hour?.month ? `${hour.month} ${hour.year}` : "N/A",
          hour?.piping_dept?.trade || "N/A",
          hour?.piping_dept?.manual_entry_hrs || 0,
          hour?.piping_dept?.isrp_main_hrs || 0,
          hour?.piping_dept?.total_hrs_pf || 0,
          hour?.mechanical_dept?.trade || "N/A",
          hour?.mechanical_dept?.manual_entry_hrs || 0,
          hour?.mechanical_dept?.isrp_main_hrs || 0,
          hour?.mechanical_dept?.total_hrs_me || 0,
          totalHrs,
          i === 0 ? totalVesselHrs : "", // only first row
          hour?.remark || "N/A",
        ];

        if (isAdmin) {
          row.push(
            budget?.month ? `${budget.month} ${budget.year}` : "N/A",
            budget?.amount
              ? `$${Number(budget.amount).toLocaleString()}`
              : "$0",
            i === 0 ? `$${Number(totalBudgetAmount).toLocaleString()}` : "",
            i === 0
              ? `$${Number(
                  vessel.total_amount_from_invoices || 0,
                ).toLocaleString()}`
              : "",
            i === 0 ? `$${Number(perhour || 0).toFixed(2)}` : "",
            i === 0 ? `$${Number(differamount || 0).toLocaleString()}` : "",
          );
        }

        row.push(i === 0 ? vessel.remarks || "N/A" : "");

        tableData.push(row);
        currentRow++;
      }

      // Merge shared fields (always)
      const commonCols = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
      commonCols.forEach((col) => {
        mergeInstructions.push({
          s: { r: currentRow - maxRows, c: col },
          e: { r: currentRow - 1, c: col },
        });
      });

      if (isAdmin) {
        mergeInstructions.push(
          {
            s: { r: currentRow - maxRows, c: 20 },
            e: { r: currentRow - 1, c: 20 },
          }, // Total Vessel HRS
          {
            s: { r: currentRow - maxRows, c: 24 },
            e: { r: currentRow - 1, c: 24 },
          }, // Total Budget Amount
          {
            s: { r: currentRow - maxRows, c: 25 },
            e: { r: currentRow - 1, c: 25 },
          }, // Invoice Total Amount
          {
            s: { r: currentRow - maxRows, c: 26 },
            e: { r: currentRow - 1, c: 26 },
          }, // Total amount per hour
          {
            s: { r: currentRow - maxRows, c: 27 },
            e: { r: currentRow - 1, c: 27 },
          }, // Invoice - Budget
          {
            s: { r: currentRow - maxRows, c: 28 },
            e: { r: currentRow - 1, c: 28 },
          }, // Vessel Remarks
        );
      } else {
        mergeInstructions.push(
          {
            s: { r: currentRow - maxRows, c: 20 },
            e: { r: currentRow - 1, c: 20 },
          }, // Total Vessel HRS
          {
            s: { r: currentRow - maxRows, c: 22 },
            e: { r: currentRow - 1, c: 22 },
          }, // Vessel Remarks for normal user
        );
      }

      serialNo++;
    });

    const ws = XLSX.utils.aoa_to_sheet(tableData);
    ws["!merges"] = mergeInstructions;

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Vessel Report");
    XLSX.writeFile(wb, "vessel-report.xlsx");
  };

  const exportExcel = () => {
    const isAdmin = userRole === "admin" || userRole === "superadmin";

    // Headers with conditional columns for admin
    const headers = [
      "S.No.",
      "Vessel Name",
      "Vessel Code",
      "Company Name",
      "Company Code",
      "Project Code",
      "Job Start Date",
      "Job End Date",
      "Job Location",
      "Job Location (code)",
      "Total Vessel HRS",
      ...(isAdmin
        ? [
            "Total Budget Amount",
            "Invoice Total Amount",
            "Total amount per hour from invoice",
            "Invoice - Budget",
          ]
        : []),
      "Vessel Remarks",
    ];

    const tableData = [headers];
    let serialNo = 1;

    filterData.forEach((vessel) => {
      // Total budget
      const totalBudgetAmount = (vessel.budget || []).reduce(
        (sum, b) => sum + (b.amount || 0),
        0,
      );

      // Total vessel hours
      const totalVesselHrs = (vessel.hours || []).reduce((sum, h) => {
        const pipingHrs = Number(h?.piping_dept?.total_hrs_pf || 0);
        const mechHrs = Number(h?.mechanical_dept?.total_hrs_me || 0);
        return sum + pipingHrs + mechHrs;
      }, 0);

      const perHour = totalVesselHrs
        ? vessel.total_amount_from_invoices / totalVesselHrs
        : 0;

      const differenceAmount =
        vessel.total_amount_from_invoices - totalBudgetAmount;

      const row = [
        serialNo,
        vessel.vessel_name ?? "N/A",
        vessel.vessel_code ?? "N/A",
        vessel.companyId?.company_name ?? "N/A",
        vessel.companyId?.company_code ?? "N/A",
        vessel.project_code ?? "N/A",
        vessel.job_start
          ? new Date(vessel.job_start).toLocaleDateString()
          : "N/A",
        vessel.job_end ? new Date(vessel.job_end).toLocaleDateString() : "N/A",
        vessel.supplier?.yard_name ?? "N/A",
        vessel.supplier?.code ?? "N/A",
        totalVesselHrs,
        ...(isAdmin
          ? [
              `$${Number(totalBudgetAmount).toLocaleString()}`,
              `$${Number(
                vessel.total_amount_from_invoices || 0,
              ).toLocaleString()}`,
              `$${Number(perHour || 0).toFixed(2)}`,
              `$${Number(differenceAmount || 0).toLocaleString()}`,
            ]
          : []),

        vessel.remarks ?? "N/A",
      ];

      tableData.push(row);
      serialNo++;
    });

    const ws = XLSX.utils.aoa_to_sheet(tableData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Vessel Report");
    XLSX.writeFile(wb, "vessel-report.xlsx");
  };

  function formatPrice(price) {
    const num = parseFloat(price);
    if (isNaN(num)) return "N/A";
    return num.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }
  const handleViewHours = (vessel) => {
    setSelectedData(vessel);
    requestAnimationFrame(() => setViewHours(true)); // safer state sync
  };

  return (
    <div>
      <ToastContainer />
      <div className="mb-4 headStyle d-flex  justify-content-between align-items-center">
        <h4 className="mb-0">Vessel</h4>
        <button
          className="button-2"
          onClick={() => {
            if (selectedCompany?.status === false) {
              toast.error(
                "The selected company is inactive. Cannot add a vessel.",
              );
            } else {
              setSelectedData(null);
              setShowForm(true);
            }
          }}
          style={{
            borderRadius: "8px",
            whiteSpace: "nowrap",
            padding: "8px 16px",
          }}
        >
          Add Vessel
        </button>
      </div>
      <div className="headStyle">
        <div className="d-flex flex-wrap align-items-center gap-3">
          <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
            <label
              htmlFor="fromDate"
              style={{ width: "-webkit-fill-available" }}
            >
              From Date
            </label>
            <input
              className="form-control"
              type="date"
              placeholder="From Date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
              style={{
                border: "1px solid #1E2A5E",
                borderRadius: "8px",
              }}
            />
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
            <label
              htmlFor="fromDate"
              style={{ width: "-webkit-fill-available" }}
            >
              To Date
            </label>
            <input
              className="form-control"
              type="date"
              placeholder="To Date"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
              style={{
                border: "1px solid #1E2A5E",
                borderRadius: "8px",
              }}
            />
          </div>
        </div>
      </div>
      <div className="headStyle mt-4 ">
        <div className="d-flex mt-2 flex-wrap align-items-center gap-3 justify-content-between">
          <div className="d-flex flex-wrap align-items-center gap-3">
            <div>
              <input
                className="form-control"
                type="search"
                placeholder="Search..."
                style={{
                  maxWidth: "100%",
                  border: "1px solid #1E2A5E",
                  borderRadius: "8px",
                }}
                onChange={handleSearchChange}
              />
            </div>
            <div className="d-flex align-items-center">
              <label className="me-2 ">Count</label>
              <select
                className="form-select no-arrow"
                value={itemsPerPage}
                onChange={(e) => setItemsPerPage(Number(e.target.value))}
                style={{ width: "auto" }}
              >
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="15">15</option>
                <option value="20">20</option>
                <option value="25">25</option>
                <option value="30">30</option>
              </select>
            </div>
          </div>
          <div>
            <button
              className="button-2 exxportBtn me-3"
              onClick={handleExportexcel}
            >
              Export to Excel
            </button>

            <button className="button-2 button-4" onClick={exportExcel}>
              Report
            </button>
          </div>
        </div>
        <div
          className="my-3 rounded"
          style={{
            overflowX: "auto",
          }}
        >
          <table
            id="my-table"
            className="table table-bordered table-responsive mb-0"
            style={{
              width: "auto",
            }}
          >
            <thead className="t_head">
              <tr className="text-center align-middle">
                <th rowSpan="2" className="align-middle">
                  Sl No
                </th>
                <th rowSpan="2" className="align-middle">
                  Vessel Name
                </th>
                <th rowSpan="2" className="align-middle">
                  Project Code
                </th>
                <th rowSpan="2" className="align-middle">
                  Vessel Code
                </th>
                <th rowSpan="2" className="align-middle">
                  Job Start Date
                </th>
                <th rowSpan="2" className="align-middle">
                  Job End Date
                </th>
                <th rowSpan="2" className="align-middle">
                  Job Location
                </th>
                <th rowSpan="2" className="align-middle">
                  Job Location (code)
                </th>

                <th rowSpan="2" className="text-center align-middle">
                  Total Hours
                </th>
                <th rowSpan="2">Hours</th>
                {["admin", "superadmin"].includes(userRole) && (
                  <>
                    <th rowSpan="2" className="text-center align-middle">
                      Total Amount per Hour form Invoice
                    </th>
                    <th rowSpan="2" className="text-center align-middle">
                      Total Amount form Invoice
                    </th>
                    <th rowSpan="2">Budget</th>

                    <th rowSpan="2">Total Budget</th>
                    <th rowSpan="2">Invoice - Budget </th>
                  </>
                )}
                <th rowSpan="2" className="align-middle">
                  Remarks
                </th>
                <th rowSpan="2" className="text-center align-middle ">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="20">
                    <div className="d-flex justify-content-center m-3">
                      <div className="spinner"></div>
                    </div>
                  </td>
                </tr>
              ) : (
                <>
                  {currentItems.length === 0 ? (
                    <>
                      <tr>
                        <td colSpan="20">
                          <div className="d-flex justify-content-center m-1">
                            <h6>Data Not Found</h6>
                          </div>
                        </td>
                      </tr>
                    </>
                  ) : (
                    <>
                      {currentItems &&
                        currentItems.map((vessel, index) => (
                          <tr key={vessel.id || index}>
                            <td>{currentPage * itemsPerPage + index + 1}</td>
                            <td>{vessel.vessel_name}</td>
                            <td>{vessel.project_code}</td>
                            <td>{vessel.vessel_code}</td>

                            <td>
                              {new Date(vessel.job_start).toLocaleDateString()}
                            </td>
                            <td>
                              {vessel.job_end === null
                                ? "Not Completed"
                                : new Date(vessel.job_end).toLocaleDateString()}
                            </td>
                            <td>{vessel?.supplier?.yard_name}</td>
                            <td>{vessel?.supplier?.code}</td>

                            <td>
                              {(() => {
                                if (
                                  Array.isArray(vessel.hours) &&
                                  vessel.hours.length > 0
                                ) {
                                  const totalHrs = vessel.hours.reduce(
                                    (sum, hourEntry) =>
                                      sum + Number(hourEntry?.total_hrs || 0),
                                    0,
                                  );
                                  return totalHrs.toFixed(2);
                                } else {
                                  return "0.00";
                                }
                              })()}
                            </td>
                            <td>
                              <button
                                className="button-2 viewBtn"
                                onClick={() => handleViewHours(vessel)}
                              >
                                View Hours
                              </button>
                            </td>

                            {["admin", "superadmin"].includes(userRole) && (
                              <>
                                <td className="text-nowrap">
                                  {(() => {
                                    // Retrieve HH.MM strings from each department with default value "0.00"
                                    const totalHours = vessel.hours
                                      ? vessel.hours.reduce(
                                          (sum, item) =>
                                            sum +
                                            (parseFloat(item.total_hrs) || 0),
                                          0,
                                        )
                                      : 0;
                                    const result =
                                      totalHours > 0
                                        ? vessel.total_amount_from_invoices /
                                          totalHours
                                        : 0;
                                    return `$ ${formatPrice(result.toFixed(2))}`;
                                  })()}
                                </td>
                                <td className="text-nowrap">
                                  {`$ ${
                                    formatPrice(
                                      vessel.total_amount_from_invoices,
                                    ) ?? 0
                                  }`}
                                </td>
                                <td>
                                  <button
                                    className="button-2 viewReportBtn"
                                    onClick={() => {
                                      setSelectedData(vessel);
                                      setViewBudget(true);
                                    }}
                                  >
                                    View Budget
                                  </button>
                                </td>

                                <td className="text-nowrap">
                                  {vessel.budget && vessel.budget.length > 0
                                    ? `$ ${formatPrice(
                                        vessel.budget.reduce(
                                          (acc, item) =>
                                            acc + Number(item.amount || 0),
                                          0,
                                        ),
                                      )}`
                                    : "N/A"}
                                </td>

                                <td className="text-nowrap">
                                  {vessel.total_amount_from_invoices != null
                                    ? vessel.budget && vessel.budget.length > 0
                                      ? `$ ${formatPrice(
                                          vessel.total_amount_from_invoices -
                                            vessel.budget.reduce(
                                              (acc, item) =>
                                                acc + Number(item.amount || 0),
                                              0,
                                            ),
                                        )}`
                                      : `$ ${formatPrice(
                                          vessel.total_amount_from_invoices,
                                        )}`
                                    : "N/A"}
                                </td>
                              </>
                            )}
                            <td>{vessel.remarks}</td>
                            <td>
                              <div className="d-flex justify-content-center align-items-center gap-2">
                                <button
                                  className="btn btn-outline-primary btn-sm me-2"
                                  onClick={() => {
                                    setSelectedData(vessel);
                                    setIsViewMode(true);
                                  }}
                                >
                                  <i className="bi bi-folder2-open"></i>
                                </button>
                                <button
                                  className="btn btn-outline-success btn-sm me-2"
                                  onClick={() => {
                                    setSelectedData(vessel);
                                    setShowForm(true);
                                  }}
                                >
                                  <i className="bi bi-pencil-square"></i>
                                </button>
                                {["admin", "superadmin"].includes(userRole) && (
                                  <>
                                    <button
                                      className="btn btn-outline-danger btn-sm"
                                      onClick={() => handleDelete(vessel._id)}
                                    >
                                      <i className="bi bi-trash3"></i>
                                    </button>
                                  </>
                                )}
                              </div>
                            </td>
                          </tr>
                        ))}
                    </>
                  )}
                </>
              )}
            </tbody>
          </table>
        </div>

        <ReactPaginate
          breakLabel="..."
          nextLabel="next >"
          onPageChange={handlePageClick}
          pageRangeDisplayed={5}
          pageCount={pageCount}
          previousLabel="< previous"
          renderOnZeroPageCount={null}
          containerClassName="pagination justify-content-center pagination-sm"
          pageClassName="page-item"
          pageLinkClassName="page-link"
          activeClassName="active"
          previousClassName="page-item"
          previousLinkClassName="page-link"
          nextClassName="page-item"
          nextLinkClassName="page-link"
          disabledClassName="disabled"
        />

        {isViewMode && (
          <VesselView
            vessel={selectedData}
            isViewMode={isViewMode}
            setIsViewMode={setIsViewMode}
          />
        )}
        {viewBudget && (
          <Budget
            vessel={selectedData}
            onClose={() => {
              setViewBudget(false);
              fetchVessel();
            }}
          />
        )}
        {viewHours && (
          <Hours
            vessel={selectedData}
            userRole={userRole}
            onClose={() => {
              setViewHours(false);
              fetchVessel();
            }}
          />
        )}

        {showForm && (
          <VesselForm
            vessel={selectedData}
            selectedCompany={selectedCompany}
            onClose={() => {
              setShowForm(false);
              fetchVessel();
            }}
          />
        )}
        {isDeleteModalOpen && (
          <div
            className={`modal fade ${isDeleteModalOpen ? "show d-block" : ""}`}
            style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)" }}
            tabIndex="-1"
            role="dialog"
            aria-labelledby="deleteModalLabel"
            aria-hidden={!isDeleteModalOpen}
            onClick={(e) => {
              if (e.target.classList.contains("modal"))
                setIsDeleteModalOpen(false);
            }}
          >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="deleteModalLabel">
                    Confirm Deletion
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                    onClick={() => setIsDeleteModalOpen(false)}
                  ></button>
                </div>
                <div className="modal-body modalWhite">
                  Are you sure you want to delete this Vessel? This action
                  cannot be undone.
                </div>
                <div className="modal-footer">
                  <button
                    className="btn btn-secondary"
                    onClick={() => setIsDeleteModalOpen(false)}
                  >
                    Cancel
                  </button>
                  <button className="btn btn-danger" onClick={confirmDelete}>
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default VesselList;
